 import { AuthGuard } from '../_guards/auth.guard';
import { Routes } from '@angular/router';
import { AppOptionEdit } from './app-option-edit.cmp';

export const AppOptionsRoutes: Routes = [
    { canActivate: [AuthGuard], path: 'appOptions', component: AppOptionEdit, data: {  roles: "appOptions",  title: 'אפשרויות' } },
  ];
